export default __webpack_public_path__ + "static/media/sandero-gallery-7.bf50e9bb.jpg";